import PropTypes from 'prop-types';
import React from 'react';

import InlineCenterSkeleton from '@glass/web/components/Skeleton/InlineCenterSkeleton';
import Typography from '@glass/web/components/base/Typography';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import useResumeWords from '@glass/shared/modules/content/staticVariations/resumeWords/useResumeWords';
import industryPropTypes from '@glass/shared/modules/jobTitles/industryPropTypes';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    paddingRight: theme.spacing(1),
  },
}));

function ContentTypography({
  name,
  loading,
  width,
  component: componentProp,
  industrySlug,
  jobTitleSlug,
  industries,
  onClick,
  prefetch,
}) {
  const { classes } = useStyles();
  const resumeWords = useResumeWords();
  const component = !loading ? componentProp : undefined;

  return (
    <Typography
      className={classes.root}
      component={component}
      industries={component ? industries : undefined}
      industrySlug={component ? industrySlug : undefined}
      jobTitleSlug={component ? jobTitleSlug : undefined}
      prefetch={component ? prefetch : undefined}
      onClick={onClick}
    >
      {loading ? (
        <InlineCenterSkeleton inline width={width} />
      ) : (
        `${name} ${resumeWords.pluralAbbreviatedCapitalized}`
      )}
    </Typography>
  );
}

ContentTypography.propTypes = {
  component: PropTypes.elementType,
  industries: PropTypes.arrayOf(PropTypes.shape(industryPropTypes)),
  industrySlug: PropTypes.string,
  jobTitleSlug: PropTypes.string,
  loading: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
  prefetch: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default React.memo(ContentTypography);
